/* eslint-disable no-mixed-operators */
import React, { useRef, useState, useEffect } from "react";
import useMember from "../../../hooks/useMember";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  checkPfNumber,
  memberLogin,
  verifyUserEmail,
} from "../../../api/apiServices";
import toast, { Toaster } from "react-hot-toast";
import "./Login.css";

const MemberLogin = () => {
  const { setMem, mempersist, setMemPersist } = useMember();

  const navigate = useNavigate();
  const location = useLocation();
  const from = location.state?.from?.pathname || "/home";

  const [state, setState] = useState({
    pf_number_email: "",
    password: "",
    isFirstTimeLogin: false,
    isChecked: false,
    regInformation: true,
  });

  const userRef = useRef();

  useEffect(() => {
    userRef.current.focus();
  }, []);

  const handleChange = (e) => {
    e.preventDefault();
    const value = e.target.value;
    setState({
      ...state,
      [e.target.name]: value,
    });
  };

  const handlePFNumber = async () => {
    let pfNumber = state.pf_number_email
      ? state.pf_number_email.toLocaleUpperCase().trim()
      : "";
    try {
      if (!pfNumber) {
        toast.error("Please enter PF Number/Email Address", {
          duration: 5000,
          className: "toast-message",
        });
        userRef.current.focus();
        return false;
      } else {
        let sendData = [];
        checkPfNumber(pfNumber)
          .then((hasPswd) => {
            if (hasPswd.status === "not_found") {
              toast.error(hasPswd.message, {
                duration: 5000,
                className: "toast-message",
              });
              setState({
                ...state,
                isFirstTimeLogin: state.isFirstTimeLogin,
              });
              userRef.current.focus();
              return false;
            }
            if (hasPswd.status === "blocked") {
              toast.error(hasPswd.message, {
                duration: 5000,
                className: "toast-message",
              });
              setState({
                ...state,
                // pf_number_email: "",
                isFirstTimeLogin: state.isFirstTimeLogin,
              });
              userRef.current.focus();
              return false;
            }
            if (!hasPswd.status) {
              setState({
                ...state,
                isFirstTimeLogin: state.isFirstTimeLogin,
              });
              let useData = hasPswd.data;
              function extractData() {
                sendData = Object.keys(useData)
                  .map(function (key) {
                    return useData[key];
                  })
                  .join("&");
              }
              extractData();
              window.location.replace(`/set_member_password?user=${sendData}`);
            } else {
                console.log("let go")
              setState({
                ...state,
                isFirstTimeLogin: !state.isFirstTimeLogin,
              });
              return true;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } catch (err) {
      if (err.response?.status === 400) {
        toast.error(err.response?.data, {
          duration: 5000,
          className: "toast-message",
        });
      } else if (err.response?.status === 401) {
        toast.error(err.response?.data, {
          duration: 5000,
          className: "toast-message",
        });
      } else {
        toast.error("Login failed", {
          duration: 5000,
          className: "toast-message",
        });
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!state.pf_number_email && !state.password) return false;

    const data = {
      pf_number_email: state.pf_number_email.trim(),
      password: state.password.trim(),
    };
    try {
      memberLogin(data).then((response) => {
        if (response.status === true) {
          const pfNumber = response?.pfNumber;
          const email = response?.email;
          const user = response?.user;
          const user_role = response?.user_role;
          const accessToken = response?.accessToken;

          setMem({ user, email, pfNumber, accessToken, user_role });
          setState({
            ...state,
            pf_number_email: "",
            password: "",
          });
          navigate(from, { replace: true });
        }
        if (response.status === false && response.login_attempts === 3) {
          toast.error(response.message, {
            duration: 5000,
            className: "toast-message",
          });
          setState({
            ...state,
            pf_number_email: "",
            password: "",
          });
          return false;
        }
        if (response.status === false) {
          toast.error(response.message, {
            duration: 5000,
            className: "toast-message",
          });
          setState({
            ...state,
            password: "",
          });
          return false;
        }
      });
    } catch (err) {
      if (err.response?.status === 400) {
        toast.error(err.response.data, {
          duration: 5000,
          className: "toast-message",
        });
        return false;
      } else if (err.response?.status === 401) {
        toast.error(err.response.data, {
          duration: 5000,
          className: "toast-message",
        });
      } else {
        toast.error("Login Failed", {
          duration: 5000,
          className: "toast-message",
        });
      }
    }
  };
  const toggleMemPersist = () => {
    setMemPersist((prev) => !prev);
  };

  useEffect(() => {
    localStorage.setItem("mempersist", mempersist);
  }, [mempersist]);

  const handleForgotPswd = () => {
    if (!state.pf_number_email) {
      toast.error("Enter your PF Number/Email Address", {
        duration: 5000,
        className: "toast-message",
      });
      userRef.current.focus();
      return false;
    }
    verifyUserEmail(state.pf_number_email).then(() => {
      navigate("/verify_secret_code");
    });
  };

  const handleCancel = (e) => {
    navigate("/");
  };




      const mainForm = (
        <>
            <form onSubmit={handleSubmit}>
                <div className="member-login-box">
                    <h3>Membership Login</h3>
                    <h4>Log in with your PF Number/Email and Password</h4>
                </div>
                {!state.isFirstTimeLogin ? (
                    <div className="form-group row">
                        <div className="col-sm-12">
                            <input
                                ref={userRef}
                                id="pf_number_email"
                                type="text"
                                autoComplete="off"
                                name="pf_number_email"
                                style={{
                                    height: "40px",
                                    fontSize: "18px",
                                }}
                                placeholder="PF Number/Email Address"
                                onChange={handleChange}
                                value={state.pf_number_email}
                                required
                                className="box"
                            />
                        </div>
                    </div>
                ) : null}
                {state.isFirstTimeLogin ? (
                    <>
                        <div className="form-group row">
                            <div className="col-sm-12">
                                <input
                                    type="password"
                                    name="password"
                                    placeholder="Password"
                                    autoComplete="off"
                                    required
                                    style={{
                                        height: "40px",
                                        fontSize: "18px",
                                    }}
                                    onChange={handleChange}
                                    value={state.password}
                                    maxLength="50"
                                    className="box"
                                />
                            </div>
                        </div>
                        <input
                            type="submit"
                            value="Login"
                            className="main-btn btn-success"
                        />
                        <div className="forgot-pswd">
                            <Link onClick={handleForgotPswd}>
                                Forgot password?
                            </Link>
                        </div>
                        <div className="persistenceCheck">
                            <input
                                type="checkbox"
                                id="memPersist"
                                onChange={toggleMemPersist}
                                checked={mempersist}
                            />
                            <label htmlFor="memPersist">
                                {" "}
                                Remember me on this device
                            </label>
                        </div>
                    </>
                ) : (
                    <>
                        <button
                            onClick={handlePFNumber}
                            type="button"
                            value="Login"
                            className="main-btn btn-success"
                        >
                            Next
                        </button>
                    </>
                )}
            </form>
        </>
    );
  

  return (
    <>
      <Toaster toastOptions={{ position: "top-center" }} />
      <div className="admin-wrapper">
        <div className="login-container">
          <div className="login-image">
            <img
              className="logo-img"
              src="/images/logos/proforum_main.jpg"
              alt="proforum"
            />
          </div>
          <form className="member-form" onSubmit={handleSubmit}>
            <fieldset>
              <legend className="login-title">Member Login</legend>
              {!state.isFirstTimeLogin ? (
                <>
                  <label htmlFor="email" className="label-login">
                    PF Number/Email Address
                  </label>
                  <div className="input-group success">
                    <input
                      ref={userRef}
                      type="text"
                      name="pf_number_email"
                      id="pf_number_email"
                      placeholder="PF Number/Email Address"
                      autoComplete="off"
                      value={state.pf_number_email}
                      onChange={handleChange}
                      required
                    />
                  </div>
                </>
              ) : null}
              {!state.isFirstTimeLogin ? (
                <>
                  <button
                    onClick={handlePFNumber}
                    type="button"
                    className="main-btn btn-success"
                  >
                    Next
                  </button>
                </>
              ) : (
                <>
                  <label htmlFor="password" className="label-login">
                    Password
                  </label>
                  <div className="input-group error">
                    <input
                      ref={userRef}
                      name="password"
                      type="password"
                      id="password"
                      autoComplete="off"
                      value={state.password}
                      placeholder="Password"
                      required
                      onChange={handleChange}
                    />
                  </div>
                  <button
                    type="submit"
                    className="btn btn-success btn-block login-button"
                  >
                    Login
                  </button>
                </>
              )}
              <div className="forgot-pswd">
                <Link onClick={handleForgotPswd}>Forgot password?</Link>
              </div>
              <div className="persistenceCheck">
                <input
                  type="checkbox"
                  id="memPersist"
                  onChange={toggleMemPersist}
                  checked={mempersist}
                />
                <label htmlFor="memPersist"> Remember me on this device</label>
              </div>
            </fieldset>
            <hr />
            <p style={{ color: "white", textAlign: "center" }}>
              <em>
                By logging in to the NDC Professionals Forum Membership
                Management System, you agree to comply fully to the Secrecy and
                Privacy of members records.
              </em>
            </p>
          </form>
          <hr />
          <button
            onClick={handleCancel}
            type="button"
            className="main-btn btn-success"
          >
            Cancel
          </button>
        </div>
      </div>
    </>
  );
};

export default MemberLogin;
